var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSapphireGemOutline = function SvgSapphireGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.25 77.25L521.75 85.75L618.25 220.25L559.75 565.75L441.75 650.75L183.25 612.25L109.75 480.25L155.75 163.25L244.25 77.25Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgSapphireGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/sapphire-gem-outline.6da40f716f5346df2e1d5a2699ff5406.svg";